export const zones = [
    {
      bgColor: "#f7b815",
      text: [
        {
          title: "Interaction zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde su se prvi put oznojeni dlanovi pretvorili u samopouzdanje, koje neće nestati ni pred pravom publikom.",
        },
        {
          title: "Centralni deo koncipiran kao otvoreni forum",
          text: <>Centralni, kružno organizovan prostor škole, koncipiran kao savremeni forum za razmenu ideja, diskusiju i timski rad, sa elementima za sedenje omogućavaju različite prostorne konfiguracije prilagođene predavanjima, panelima, radionicama i timskim sastancima. <br/><br/>Kroz aktivnosti u ovoj zoni učenici razvijaju veštine javnog nastupa, argumentovane komunikacije, timske saradnje i liderstva.</>,
          list: ["64 m²", "aktivna zona", "kolektivno"]
        },
      ],
    },
    {
      bgColor: "#427042",
      text: [
        {
          title: "Education zone",
          subtitle: "Ovo nije",
          text: "Ovo je mesto gde je neko položio svoj prvi Cambridge Checkpoint ispit. Danas se na zidu njegove kancelarije nalazi diploma Cambridge univerziteta.",
        },
        {
          title: "Obrazovni ambijent koji podstiče aktivno učešće",
          text: <>Fleksibilna organizacija prostora uz funkcionalan raspored i savremenu tehničku opremu omogućava realizaciju različitih nastavnih formata, što podstiče veću angažovanost učenika, efikasnije usvajanje znanja i aktivnije učešće u nastavnom procesu.<br/><br/>Digitalni alati dodatno doprinose prilagođavanju individualnim stilovima učenja i unapređuju interakciju između nastavnika i učenika.</>,
          list: [<>231 m² / <br />10 učionica</>, "interaktivna zona", 'u grupama']
        },
      ],
    },
  ];